export class Country {
    id;
    label;
    value;
}
export const countries = [
    { id: 'DE', label: 'Deutschland', value: 'DE' },
    { id: 'AT', label: 'Österreich', value: 'AT' },
];
export const countryRegex = countries.map((country) => country.value).join('|');
export const GERMANY = countries[0];
export const findCountryByValue = (value) => {
    return countries.find((country) => country.value === value);
};
//# sourceMappingURL=countries.js.map